const applyPlanGating = (flags, merchantFlags) => ({
  ...flags,
  appointments: flags.appointments && !!merchantFlags?.appointments?.enabled,
  events: flags.events && !!merchantFlags?.events?.enabled,
});

export default applyPlanGating;
